<template>
  <SettingsSection>
    <SettingsSectionTitle> Device </SettingsSectionTitle>
    <SettingsSubsection title="Supervisor">
      <SettingsSupervisorPinForm />
    </SettingsSubsection>
    <SettingsSubsection title="Access Control">
      <SettingsToggle
        label="Require supervisor pin to access transaction history"
        :model-value="accessControlRestrict.transactions"
        @update:model-value="
          (event) => onSetAccess('transactions', event)
        "
      />
      <SettingsToggle
        label="Require supervisor pin to access reports"
        :model-value="accessControlRestrict.reports"
        @update:model-value="
          (event) => onSetAccess('reports', event)
        "
      />
    </SettingsSubsection>
    <SettingsSubsection title="Printing">
      <SettingsToggle
        label="Enable Transaction Receipts"
        :model-value="isTransactionReceiptsEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting(
              'isTransactionReceiptsEnabled',
              value
            )
        "
      />
      <SettingsToggle
        label="Enable Automatic Merchant Receipts"
        :model-value="
          tenant.isAutomaticMerchantReceiptEnabled
        "
        @update:model-value="
          (value) =>
            onUpdateSetting(
              'isAutomaticMerchantReceiptEnabled',
              value
            )
        "
      />
      <SettingsToggle
        label="Print QR Code on Reciepts"
        :model-value="isReceiptQrCodeEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting('isReceiptQrCodeEnabled', value)
        "
      />
    </SettingsSubsection>
  </SettingsSection>
</template>

<script setup lang="ts">
import type { PartialUpdateTenant } from "@/services/settings/partialUpdateSettings"

const {
  tenant,
  accessControlRestrict,
  isTransactionReceiptsEnabled,
  isReceiptQrCodeEnabled,
  setTenantState,
} = useTenant()

const onSetAccess = async (
  viewName: "transactions" | "reports",
  newValue: boolean
) => {
  try {
    const newState = await partialUpdateSettings({
      [viewName === "transactions"
        ? "accessControlRestrictTransactions"
        : "accessControlRestrictReports"]: newValue,
    })
    setTenantState(newState)
  } catch {
    toast.error("Failed to update access control settings")
  }
}

const onUpdateSetting = async <
  T extends keyof PartialUpdateTenant,
>(
  setting: T,
  value: PartialUpdateTenant[T]
) => {
  try {
    const newState = await partialUpdateSettings({
      [setting]: value,
    })
    setTenantState(newState)
  } catch {
    toast.error("Failed to update setting")
  }
}
</script>
